import { render, staticRenderFns } from "./PageRegister.vue?vue&type=template&id=a2470fc4&scoped=true"
import script from "./PageRegister.vue?vue&type=script&lang=js"
export * from "./PageRegister.vue?vue&type=script&lang=js"
import style0 from "./PageRegister.vue?vue&type=style&index=0&id=a2470fc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2470fc4",
  null
  
)

export default component.exports